export function initialize() {
    document.addEventListener('click', function(e) {
        var subBtn = e.target.closest('[data-btn="minus"]');

        if(subBtn !== null) {
            console.log('101010');
            e.preventDefault();
            sub(subBtn);
        } else {
            var addBtn = e.target.closest('[data-btn="plus"]');

            if(addBtn !== null) {
                console.log('111111');
                e.preventDefault();
                add(addBtn);
            }
        }

    });
}

function add(btn)
{
    var input = getInput(btn);

    if(input) {
        try{
            input.stepUp();
        }catch(ex){
            let step=Number(input.step || 1);
            console.log('STEPUP', step);
            input.value = Number(input.value) + step;
        }
    }
}

function sub(btn)
{
    var input = getInput(btn);

    if(input) {
        try{
            input.stepDown();
        }catch(ex){
            let step=Number(input.step || 1);
            input.value = Number(input.value) - step;
            if(input.value < input.min) {
                input.value = input.min;
            }
        }
    }
}

function getInput(btn)
{
    return btn
        .closest('[data-btn="area"]')
        .querySelector('[type="number"]');
}
